<page-toolbar [pageActions]="pageActions" [title]="pipeImport ? pipeImport.title : title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading || !pipeImport" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!pipeImport">
  <div [ngClass]="{ 'left': testResult }">
    <smart-input [(model)]="pipeImport" key="title"></smart-input>
    <div class="field-group">
      <smart-input [(model)]="pipeImport" key="autoUpdate"></smart-input>
      <smart-input [(model)]="pipeImport" key="autoUpdateInterval"></smart-input>
      <smart-input [(model)]="pipeImport" key="executionTime"></smart-input>
    </div>
    <div class="field-group">
      <smart-input [(model)]="pipeImport" key="executableByUser"></smart-input>
      <smart-input [(model)]="pipeImport" key="longRunning"></smart-input>
      <smart-input [(model)]="pipeImport" key="nextImportId"></smart-input>
    </div>
    <mat-card appearance="outlined">
      <mat-card-title>Owner Organisation<span *ngIf="organisation">: {{organisation.title}}</span></mat-card-title>
      <div class="button-right-container">
        <button (click)="assignOrganisation()" class="ibexfusion-raised-button" mat-button>assign organisation</button>
        <button (click)="removeOrganisation()" *ngIf="!!organisation" class="ibexfusion-raised-button" mat-button>remove organisation
        </button>
      </div>
      <div class="spacer"></div>
      <mat-expansion-panel *ngFor="let module of pipeImport.modules; let i = index">
        <mat-expansion-panel-header>
          <mat-panel-title>{{module.group}} - {{module.module}}</mat-panel-title>
          <button (click)="onTest(i, $event)" *ngIf="!!pipeImport && pipeImport.modules && module.group !== 'Target'" mat-icon-button>
            <mat-icon>verified</mat-icon>
          </button>
          <button (click)="onRemove(i)" *ngIf="!!pipeImport && pipeImport.modules" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
          <button (click)="onMoveUp(i, $event)" *ngIf="!!pipeImport && pipeImport.modules" [disabled]="i === 0" mat-icon-button>
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button (click)="onMoveDown(i, $event)" *ngIf="!!pipeImport && pipeImport.modules"
                  [disabled]="i === pipeImport.modules.length - 1"
                  mat-icon-button>
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </mat-expansion-panel-header>

        <default-form
          *ngIf="(module.group != 'Request' || module.module !== 'Upload') && !pipeImport.modules[i - 1]?.data['useAsConfig']"
          [entry]="module.data"></default-form>

        <div *ngIf="module.group === 'Request' && module.module === 'Upload'">
          <input (change)="fileGiven($event)" hidden id="upload" type="file"/>
          <label class="md-button md-raised md-primary" for="upload">Choose File</label>
          <smart-input [(model)]="module.data" key="encoding"></smart-input>
        </div>

      </mat-expansion-panel>
    </mat-card>

    <speed-dial-fab (fabClick)="onModuleSelected($event)" [fabButtons]="fabButtons" class="speed-dial-container"></speed-dial-fab>
    <button (click)="onSave()" *ngIf="!!pipeImport" mat-raised-button>Save</button>
  </div>
  <div *ngIf="testResult" class="right">
    <mat-expansion-panel class="result">
      <mat-expansion-panel-header>
        <mat-panel-title>Result</mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngIf="testResultIsObject">
        <mat-slide-toggle [(ngModel)]="showAsString" color="primary">Show as string</mat-slide-toggle>
        <br>
        {{showAsString}}
        <ngx-json-viewer *ngIf="!showAsString" [expanded]="true" [json]="testResult"></ngx-json-viewer>
        <textarea *ngIf="showAsString" readonly rows="30">{{stringify(testResult)}}</textarea>
      </ng-container>
      <textarea *ngIf="!testResultIsObject" readonly rows="30">{{testResult}}</textarea>
    </mat-expansion-panel>
  </div>
</page-content>
